// Interim Appointment store.
// Moving some crud methods before full conversion

import view from 'bz-stores/lib/diary-view-store';
import Api from 'tm3-core/api';

class AppointmentStore {
  onUpdate(appt) {
    view.processing = true;
    let originalStart = appt.startDateTime;
    let originalEnd = appt.endDateTime;

    let roomId = appt.roomId;
    let practitionerId = appt.practitionerId;

    if (view.resourceMode === 'room') {
      roomId = appt.resourceId || roomId;
    } else {
      practitionerId = appt.resourceId || practitionerId;
    }

    let request = {
      id: appt.id,
      roomId: roomId,
      apptType: appt.type,
      locationId: appt.locationId,
      endDateTime: appt.endDateTime,
      practitionerId: practitionerId,
      resourceMode: view.resourceMode,
      yesToWarnings: appt.yesToWarnings,
      startDateTime: appt.startDateTime,
      resendConfirmations: appt.resendConfirmations,
      reminderType: !!appt.reminderType ? appt.reminderType : null
    };

    return Api.post('/api/appointment/update', request);
  }

  onRemove(id) {
    return Api.post('/api/appointment/delete', { id: id });
  }
}

export default new AppointmentStore();
